// SELECCIONAR SIGUIENTE DIA
const tomorrow = new Date()
tomorrow.setDate(new Date().getDate() + 1)

export { tomorrow }
